import "./DoctorModalFooter.scss";

type DoctorModalFooterProps = {
  children?: React.ReactNode;
};

export const DoctorModalFooter = ({ children }: DoctorModalFooterProps) => {
  return (
    <footer className="ui-consent-modal-footer bg-white shadow">
      {children}
    </footer>
  );
};
